import { render, staticRenderFns } from "./OilUseRegistration.vue?vue&type=template&id=4b07dfe0&scoped=true&"
import script from "./OilUseRegistration.vue?vue&type=script&lang=js&"
export * from "./OilUseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OilUseRegistration.vue?vue&type=style&index=0&id=4b07dfe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07dfe0",
  null
  
)

export default component.exports